import { render } from "./CustomerDashboardContentLoader.vue?vue&type=template&id=83a8ee06&scoped=true&ts=true"
import script from "./CustomerDashboardContentLoader.vue?vue&type=script&lang=ts"
export * from "./CustomerDashboardContentLoader.vue?vue&type=script&lang=ts"

import "./CustomerDashboardContentLoader.vue?vue&type=style&index=0&id=83a8ee06&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a8ee06"]])

export default __exports__